import React from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhone, FaFileAlt, FaFileWord } from 'react-icons/fa';

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center pt-24 bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900"
      style={{
        backgroundImage: `url('/tile.png'), linear-gradient(to bottom right, var(--tw-gradient-stops))`,
        backgroundRepeat: 'repeat',
        backgroundSize: 'auto',
        backgroundBlendMode: 'overlay',
      }}
    >
      <div className="container mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h1
            className="text-4xl sm:text-5xl md:text-7xl font-bold mb-6 dark:text-gray-100"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <span className="gradient-text">Sean Yeomans</span>
          </motion.h1>
          
          <motion.h2
            className="text-lg sm:text-2xl md:text-3xl text-gray-600 dark:text-gray-300 mb-8 font-medium"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Consultant/Developer
          </motion.h2>
          
          <motion.p
            className="text-base sm:text-lg md:text-xl text-gray-600 dark:text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Full-stack developer with 25+ years of experience spanning multimedia development, 
            interactive design, and enterprise solutions. From early Flash and Director applications 
            to modern React and .NET platforms, I've evolved with technology while maintaining 
            a focus on innovative user experiences and robust content management systems.
          </motion.p>

          <motion.div
            className="flex flex-wrap items-center justify-center gap-4 mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <button
              onClick={() => scrollToSection('#projects')}
              className="btn btn-primary"
            >
              View My Work
            </button>
            <button
              onClick={() => scrollToSection('#contact')}
              className="btn btn-secondary"
            >
              Get In Touch
            </button>
          </motion.div>

          <motion.div
            className="flex justify-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.85 }}
          >
            <div className="flex items-center gap-2 bg-gray-100 dark:bg-gray-800 p-3 rounded-lg shadow-inner">
              <span className="font-semibold text-gray-700 dark:text-gray-200 px-2">Resume:</span>
              <a
                href="/Sean_Yeomans_Resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary flex items-center justify-center gap-2"
                download
              >
                <FaFileAlt /> PDF
              </a>
              <a
                href="/Sean_Yeomans_Resume.docx"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary flex items-center justify-center gap-2"
                download
              >
                <FaFileWord /> Word
              </a>
            </div>
          </motion.div>

          <motion.div
            className="flex flex-col sm:flex-row justify-center items-center sm:space-x-6 space-y-2 sm:space-y-0"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
          >
            <motion.a
              href="mailto:sean@yeomans.ca"
              className="flex items-center space-x-2 text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaEnvelope size={20} />
              <span>sean@yeomans.ca</span>
            </motion.a>
            
            <motion.a
              href="tel:204-951-1274"
              className="flex items-center space-x-2 text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-200"
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPhone size={20} />
              <span>204-951-1274</span>
            </motion.a>
          </motion.div>

          <motion.div
            className="mt-8 text-gray-500 dark:text-gray-400"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.2 }}
          >
            <p>Winnipeg, MB, Canada</p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero; 